import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstance, { microServices } from 'network/apis'
import { SuccessMessage } from 'helpers/messages'

/**
 * Service to update admin user details
 */
export const updateAdminDetailsService = (userData) => {
  return axiosInstance(METHOD_TYPES.put, '/admins/update', userData, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: SuccessMessage.adminDetailsUpdated
  })
}

/**
 * Service to create admin user
 * @param {object} data - object contains all required properties to create new admin
 */
export const createAdminService = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/admins/create', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: SuccessMessage.adminCreated
  })
}

/**
 * Service to fetch all admin users
 */
export const getAllAdminsService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/admins/list', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

/**
 * Service to generate reset password link
 */
export const forgotPasswordService = (email) => {
  return axiosInstance(METHOD_TYPES.post, '/admins/forgot-password', { email }, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: SuccessMessage.resetPasswordLinkGenerated
  })
}

/**
 * Service to reset password
 */
export const resetPasswordService = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/admins/reset-password', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: SuccessMessage.resetPasswordSuccessfully
  })
}

/**
 * Service to change password
 * @param {object} data - object contains old and new password
 */
export const updatePasswordService = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/admins/change-password', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: SuccessMessage.changePassword
  })
}

/**
 * Service to generate QR
 */
export const generateQrCodeService = () => {
  return axiosInstance(METHOD_TYPES.post, '/admins/generate-secret-code', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.page
  })
}

/**
 * Service to verify 2fa authenticate token
 * @param {object} data - object contains token
 */
export const verifyTwoFactorTokenService = (token) => {
  return axiosInstance(METHOD_TYPES.post, '/admins/firstTime-2fa-authenticate-token', { token }, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: SuccessMessage.twoFactorEnabledSuccessfully
  })
}

/**
 * Service to deactivate 2fa authenticate token
 */
export const deactivateTwoFactorService = () => {
  return axiosInstance(METHOD_TYPES.post, '/admins/deactivate-2fa', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: SuccessMessage.twoFactorDisabledSuccessfully
  })
}

export const getAdminInfoService = () => {
  return axiosInstance(METHOD_TYPES.get, '/admins/details', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table
  })
}
